import React, { useEffect } from 'react';
import { getBasemapFamilyLabel } from '../utils/mapProviderSettings';

/** 左下角只显示图源名称，不带叠加层名 */
export function buildBasemapAttributionText(basemapId) {
  return getBasemapFamilyLabel(basemapId) || basemapId || '地图';
}

/**
 * 地图左下角图源名称（随底图切换更新），并隐藏 Mapbox 默认 logo
 */
export default function DashboardBasemapAttribution({
  basemapId,
  mapContainerSelector = '.map-container'
}) {
  const text = buildBasemapAttributionText(basemapId);

  useEffect(() => {
    const hideNative = () => {
      document.querySelectorAll('.mapboxgl-ctrl-attrib, .mapboxgl-ctrl-logo').forEach((el) => {
        el.style.display = 'none';
      });
    };
    hideNative();
    const root = document.querySelector(mapContainerSelector);
    if (!root) return undefined;
    const observer = new MutationObserver(hideNative);
    observer.observe(root, { childList: true, subtree: true });
    return () => observer.disconnect();
  }, [basemapId, mapContainerSelector]);

  return (
    <div
      className="zhxt-basemap-attribution"
      title={`当前图源：${text}`}
      style={{
        position: 'absolute',
        left: 8,
        bottom: 6,
        zIndex: 16,
        maxWidth: 'min(52vw, 280px)',
        padding: '2px 8px',
        borderRadius: 4,
        background: 'rgba(255,255,255,0.88)',
        color: '#333',
        fontSize: 11,
        lineHeight: 1.4,
        boxShadow: '0 1px 4px rgba(0,0,0,0.12)',
        pointerEvents: 'none',
        whiteSpace: 'nowrap',
        overflow: 'hidden',
        textOverflow: 'ellipsis',
        userSelect: 'none'
      }}
    >
      {text}
    </div>
  );
}
